import { format } from "bytes";
const BYTES_OPTIONS = {
  decimalPlaces: 0,
  unitSeparator: " "
};
const STRINGS = {
  cancelButtonLabel: file => `Cancel uploading ${file.name}`,
  errorPrefix: "Error, ",
  fileFormatErrorMessage: () => `File format not accepted`,
  fileSizeErrorMessage: () => `File size exceeds maximum`,
  progressCancelledMessage: file => `${file.name} (${format(file.size, BYTES_OPTIONS)}) Upload canceled`,
  progressFailedMessage: () => "Upload failed",
  progressStartMessage: () => "Upload started",
  progressSucceededMessage: () => "Upload completed",
  removeButtonLabel: file => file ? `Remove file, ${file.name}` : `Remove file`,
  replaceFileButtonLabel: "Replace file",
  requiredErrorMessage: label => `Enter ${label}`,
  selectedText: "selected",
  selectFileButtonLabel: "Select file",
  selectionStatus: file => file ? `${file.name} (${format(file.size, BYTES_OPTIONS)})` : `No file selected`
};
export default STRINGS;